const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

// For localhost we want to proxy requests to the fake server at http://localhost:5000 so we
// include this /local/ portion in our paths and tell vite.config.ts to proxy requests with
// /local/ in them.
const getBaseUrl = () => isLocalhost ? `${window.travURI}local/` : window.travURI

export { getBaseUrl, isLocalhost }